export default "__VITE_ASSET__Dp$ttO$K__"